import { useState, useEffect, useCallback, useRef } from 'react';
import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function DataTokenTooltipManager({
  editor
}) {
  const [title, setTitle] = useState('');
  const [target, setTarget] = useState(undefined);
  const lastTarget = useRef(target);
  useEffect(() => {
    lastTarget.current = target;
  });
  const handleRemove = useCallback(() => {
    if (lastTarget.current) {
      setTitle('');
      setTarget(undefined);
    }
  }, [lastTarget]);
  useEffect(() => {
    const handleMouseOver = ({
      target: newTarget
    }) => {
      if (!newTarget) {
        handleRemove();
        return;
      }
      const typedTarget = newTarget;
      const hasDataSensitivity = typedTarget.getAttribute('data-mce-data-sensitivity') === 'true';
      const hasTruncatedLabel = typedTarget.getAttribute('data-mce-truncated-label') === 'true';
      if (newTarget === lastTarget.current) {
        return;
      } else if (hasDataSensitivity) {
        setTitle(I18n.text('TinymcePlugins.hsdatatoken.dataSensitivityTooltip'));
        setTarget(typedTarget);
      } else if (typedTarget.hasAttribute('data-mce-token-path') && hasTruncatedLabel) {
        setTitle(typedTarget.getAttribute('data-mce-property-label') || '');
        setTarget(typedTarget);
      } else {
        handleRemove();
      }
    };
    editor.on('mouseover', handleMouseOver);
    return () => {
      editor.off('mouseover', handleMouseOver);
    };
  }, [editor, lastTarget, handleRemove]);
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "data-token-tooltip",
    open: !!target,
    target: target,
    title: title,
    children: /*#__PURE__*/_jsx(_Fragment, {})
  });
}